import { Page } from "./page";

export class Content extends Page
{
}
